import { render, staticRenderFns } from "./CKEditorContent.vue?vue&type=template&id=ae8723f4"
import script from "./CKEditorContent.vue?vue&type=script&lang=ts"
export * from "./CKEditorContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports